import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isAdminRole } from '../lib/roles';
import { getInitials } from '../lib/portal';
import PortalIcon from './PortalIcon';

function PortalNavbar({ user, logout }) {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const accountRef = useRef(null);
  const initials = getInitials(user, null);

  useEffect(() => {
    const handlePointerDown = (event) => {
      if (accountRef.current && !accountRef.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener('pointerdown', handlePointerDown);
    return () => document.removeEventListener('pointerdown', handlePointerDown);
  }, []);

  const active = (path) => {
    if (path === '/portal') return location.pathname === '/portal';
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  return (
    <nav className="portal-nav">
      <Link className="portal-nav-brand" to="/portal" aria-label="ESA Portal">
        <span className="portal-nav-mark">E</span>
        <strong>ESA / portal cliente</strong>
      </Link>

      <div className="portal-nav-links">
        <Link className={`portal-nav-link ${active('/portal') ? 'is-active' : ''}`} to="/portal">
          <PortalIcon name="grid" size={16} /><span>Resumen</span>
        </Link>
        <Link className={`portal-nav-link ${active('/pedidos') ? 'is-active' : ''}`} to="/pedidos">
          <PortalIcon name="box" size={16} /><span>Pedidos</span>
        </Link>
        <Link className={`portal-nav-link ${active('/colectas') ? 'is-active' : ''}`} to="/colectas">
          <PortalIcon name="truck" size={16} /><span>Colectas</span>
        </Link>
        <Link className={`portal-nav-link ${active('/soporte') ? 'is-active' : ''}`} to="/soporte">
          <PortalIcon name="help" size={16} /><span>Soporte</span>
        </Link>
      </div>

      <div className="portal-nav-account" ref={accountRef}>
        <button
          type="button"
          className="portal-account-trigger"
          aria-expanded={open}
          aria-label="Abrir menú de perfil"
          onClick={() => setOpen((value) => !value)}
        >
          <span className="portal-avatar">{initials}</span>
          <span>Mi cuenta</span>
          <PortalIcon name="arrow" size={14} className="portal-account-chevron" />
        </button>
        {open ? (
          <div className="portal-account-menu">
            <Link to="/perfil" onClick={() => setOpen(false)}>
              <PortalIcon name="settings" size={16} /> Configuración
            </Link>
            <button type="button" onClick={logout}>
              <PortalIcon name="logout" size={16} /> Salir
            </button>
          </div>
        ) : null}
      </div>
    </nav>
  );
}

export default function Navbar() {
  const { user, logout, isAuthenticated, authReady } = useAuth();
  const location = useLocation();
  const admin = isAdminRole(user?.rol);
  const portal = isAuthenticated && !admin;

  if (portal) return <PortalNavbar user={user} logout={logout} />;

  const isActive = (path) => {
    if (path === '/admin') return location.pathname === '/admin' || location.pathname.startsWith('/admin/');
    return location.pathname === path;
  };

  return (
    <nav className="navbar">
      <div className="nav-brand"><Link to="/">Cotizador real</Link></div>
      <div className="nav-links">
        {admin ? (
          <>
            <Link to="/admin" className={isActive('/admin') ? 'active' : ''}>Admin</Link>
            <Link to="/admin/tarifas" className={isActive('/admin/tarifas') ? 'active' : ''}>Tarifas</Link>
            <Link to="/admin/reglas" className={isActive('/admin/reglas') ? 'active' : ''}>Reglas</Link>
            <Link to="/admin/tiendanube" className={isActive('/admin/tiendanube') ? 'active' : ''}>Tiendanube</Link>
            <Link to="/admin/tiendanube/pedidos" className={isActive('/admin/tiendanube/pedidos') ? 'active' : ''}>Pedidos</Link>
          </>
        ) : null}
        <Link to="/estado" className={isActive('/estado') ? 'active' : ''}>Estado</Link>
        {!isAuthenticated ? <Link to="/login" className={isActive('/login') ? 'active' : ''}>Ingresar</Link> : null}
      </div>
      <div className="nav-auth">
        {!authReady ? <span className="nav-user">Validando sesión...</span> : null}
        {authReady && isAuthenticated ? (
          <>
            <span className="nav-user">{user?.email || 'Usuario'} {user?.rol ? `(${user.rol})` : ''}</span>
            <button className="btn-secondary btn-inline" onClick={logout}>Salir</button>
          </>
        ) : null}
        {authReady && !isAuthenticated ? <Link to="/login" className="btn-secondary btn-inline">Afiliarme</Link> : null}
      </div>
    </nav>
  );
}
